export default __webpack_public_path__ + "static/media/element_20.cbf8bf54.avif";